export const EventQuestionType = {
  OPEN_ENDED: 'default',
  BINARY: 'binary',
  MULTIPLE_CHOICE: 'multiple',
  MULTIPLE_RATING: 'multiple_rating',
  SCALE: 'scale',
  SCALE_5: 'scale_5',
  SCALE_10: 'scale_10',
  STACK_RANK: 'stack_rank',

  isOpenEndedType (type) {
    return this.OPEN_ENDED === type;
  },

  isBinaryType (type) {
    return this.BINARY === type;
  },

  isMultipleType (type) {
    return this.MULTIPLE_CHOICE === type;
  },

  isMultipleRatingType (type) {
    return this.MULTIPLE_RATING === type;
  },

  isStackRankType (type) {
    return this.STACK_RANK === type;
  },

  isScaleType (type) {
    return this.SCALE_10 === type || this.SCALE_5 === type || this.SCALE === type;
  }
};

export const eventQuestionTypeFromString = (type) => {
  const lower = (type || '').toLowerCase();
  switch (lower) {
    case EventQuestionType.OPEN_ENDED:
    case EventQuestionType.BINARY:
    case EventQuestionType.MULTIPLE_CHOICE:
    case EventQuestionType.MULTIPLE_RATING:
    case EventQuestionType.STACK_RANK:
    case EventQuestionType.SCALE:
    case EventQuestionType.SCALE_5:
    case EventQuestionType.SCALE_10:
      return lower;
    default:
      throw Error(`Invalid event question type: ${type}`);
  }
};

